module.exports = __webpack_public_path__ + "img/werbe-logo-white.b973d36.svg";